import { render, staticRenderFns } from "./Moneylog.vue?vue&type=template&id=2298d734&scoped=true"
import script from "./Moneylog.vue?vue&type=script&lang=js"
export * from "./Moneylog.vue?vue&type=script&lang=js"
import style0 from "./Moneylog.vue?vue&type=style&index=0&id=2298d734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298d734",
  null
  
)

export default component.exports